import { FC } from "react";
import { useRecoilValue } from "recoil";

import { useCrudEditContext } from "@ryde/redux";
import { formTabControlsSF, ICourseDto } from "@ryde/shared";

import { FormControlsWrapper } from "../../form.controls.wrapper";
import { CourseTabsContentWrapperStyled } from "./course.styled";

export const CourseTabsTabAdvanced: FC = () => {
  const { entity } = useCrudEditContext<ICourseDto>();
  const currentTabControls = useRecoilValue(formTabControlsSF(entity));
  return (
    <CourseTabsContentWrapperStyled>
      <FormControlsWrapper controls={currentTabControls} />
    </CourseTabsContentWrapperStyled>
  );
};
